<template>
  <div class="splash-wrap">
    <el-form size="small" ref="globalForm" :model="global" label-width="160px" class="global-form">
      <div class="common-form">全局设置</div>
      <el-form-item label="开启动态开屏">
        <el-radio-group v-model="global.enabled">
          <el-radio label="1">开启</el-radio>
          <el-radio label="0">关闭</el-radio>
        </el-radio-group>
        <div class="tips">关闭后 APP 不再展示远程开屏图（splash 页可秒进首页）</div>
      </el-form-item>
      <!-- 前台未使用，暂不展示
      <el-form-item label="默认展示秒数">
        <el-input-number v-model="global.default_duration" :min="1" :max="30"></el-input-number>
        <span class="tips-inline">素材未单独设置时使用</span>
      </el-form-item>
      <el-form-item label="展示间隔(小时)">
        <el-input-number v-model="global.show_interval_hours" :min="0" :max="720"></el-input-number>
        <div class="tips">同一素材间隔 N 小时再展示；0=每次冷启动都展示</div>
      </el-form-item>
      -->
      <el-form-item label="跳过按钮文案">
        <el-input v-model="global.skip_text" class="max-w460" placeholder="跳过"></el-input>
      </el-form-item>
      <div class="common-button-wrapper">
        <el-button type="primary" @click="saveGlobal" v-auth="'/appsetting/appsplash/saveGlobal'">保存全局设置</el-button>
      </div>
    </el-form>

    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/appsetting/appsplash/add'">添加开屏素材</el-button>
    </div>

    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border v-loading="loading">
          <el-table-column prop="title" label="名称" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="预览" width="90">
            <template slot-scope="scope">
              <img v-if="scope.row.image_url" v-img-url="scope.row.image_url" class="splash-thumb">
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80">
            <template slot-scope="scope">{{ scope.row.status == 1 ? '已发布' : '草稿' }}</template>
          </el-table-column>
          <el-table-column prop="platform" label="平台" width="80"></el-table-column>
          <!-- 前台未使用
          <el-table-column prop="duration" label="秒数" width="60"></el-table-column>
          -->
          <el-table-column prop="sort" label="优先级" width="70"></el-table-column>
          <el-table-column label="有效期" min-width="160">
            <template slot-scope="scope">
              <span v-if="!scope.row.start_time && !scope.row.end_time">不限</span>
              <span v-else>{{ formatTime(scope.row.start_time) }} ~ {{ formatTime(scope.row.end_time) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="link_type" label="点击" width="90">
            <template slot-scope="scope">{{ linkTypeText(scope.row.link_type) }}</template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="140"></el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="editClick(scope.row)" v-auth="'/appsetting/appsplash/edit'">编辑</el-button>
              <el-button type="text" size="small" @click="deleteClick(scope.row)" v-auth="'/appsetting/appsplash/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open="open_add" @close="closeAdd"></Add>
    <Edit :open="open_edit" :model="curModel" @close="closeEdit"></Edit>
  </div>
</template>

<script>
import AppSettingApi from '@/api/appsetting.js';
import Add from './splash/Add.vue';
import Edit from './splash/Edit.vue';

export default {
  components: { Add, Edit },
  data() {
    return {
      loading: true,
      global: {
        enabled: '1',
        default_duration: 3,
        show_interval_hours: 24,
        skip_text: '跳过'
      },
      tableData: [],
      pageSize: 15,
      totalDataNumber: 0,
      curPage: 1,
      open_add: false,
      open_edit: false,
      curModel: {}
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const self = this;
      self.loading = true;
      AppSettingApi.appSplashIndex({ page: self.curPage, list_rows: self.pageSize }, true)
        .then(res => {
          self.loading = false;
          if (res.data.global) {
            self.global = Object.assign({}, self.global, res.data.global);
            self.global.default_duration = parseInt(self.global.default_duration, 10) || 3;
            self.global.show_interval_hours = parseInt(self.global.show_interval_hours, 10) || 0;
          }
          if (res.data.list) {
            self.tableData = res.data.list.data || [];
            self.totalDataNumber = res.data.list.total || 0;
          }
        })
        .catch(() => { self.loading = false; });
    },
    saveGlobal() {
      AppSettingApi.saveAppSplashGlobal(this.global, true).then(() => {
        this.$message.success('全局设置已保存');
      });
    },
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },
    addClick() { this.open_add = true; },
    editClick(row) { this.curModel = row; this.open_edit = true; },
    closeAdd(e) {
      this.open_add = false;
      if (e && e.type === 'success') this.getData();
    },
    closeEdit(e) {
      this.open_edit = false;
      if (e && e.type === 'success') this.getData();
    },
    deleteClick(row) {
      this.$confirm('确定删除该开屏素材？', '提示', { type: 'warning' }).then(() => {
        AppSettingApi.delAppSplash({ splash_id: row.splash_id }, true).then(() => {
          this.$message.success('删除成功');
          this.getData();
        });
      }).catch(() => {});
    },
    formatTime(ts) {
      if (!ts) return '不限';
      const d = new Date(ts * 1000);
      return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
    },
    linkTypeText(t) {
      return { 0: '无', 1: '外链', 2: 'APP内页' }[t] || '无';
    }
  }
};
</script>

<style scoped>
.splash-wrap { padding-bottom: 20px; }
.global-form { margin-bottom: 20px; background: #fafafa; padding: 16px; border-radius: 4px; }
.tips { color: #999; font-size: 12px; line-height: 1.4; margin-top: 4px; }
.tips-inline { color: #999; font-size: 12px; margin-left: 8px; }
.splash-thumb { width: 48px; height: 48px; object-fit: cover; border-radius: 4px; }
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appopen/part/splash.vue